// extracted by mini-css-extract-plugin
module.exports = {"roomInfoWrapper":"RoomInfo_roomInfoWrapper__Q41_Y","tableContent":"RoomInfo_tableContent__3TZyr"};